<template>
  <div
    class="matrix_layoutMain container matrix_layoutUseMatrix"
    :class="[getClassNameContainer, getBundleClass]"
  >
    <div class="row">
      <div class="col-md-9 matrix_layoutMatrixContainerColMain">
        <div class="matrix_layoutHeader">
          <appProductPartsNamesContainer></appProductPartsNamesContainer>
        </div>
        <div class="matrix_productPartsMainContainer matrix_table">
          <component :is="getBundleProductPartType"></component>
          <appBackToMatrixButton></appBackToMatrixButton>
          <appUploadTable></appUploadTable>
          <appPersonalizationButton
            v-show="getMatrixComplete && getPersonalizationFullPage"
            v-if="!getUploadPersonalizationOneProduct"
            class="matrix_personzalizeButtonMain"
          ></appPersonalizationButton>
        </div>
        <div v-if="getBundleIsActive" class="matrix_summaryInformation">
          <appUploadContainerBundle></appUploadContainerBundle>
        </div>
        <div class="matrix_summaryInformation">
          <appSummaryTable></appSummaryTable>
          <appInformationTable></appInformationTable>
        </div>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
      </div>
      <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
        <appCustomerNotesTable v-if="getShowCustomerNotes">
          <appCustomerNotes></appCustomerNotes>
        </appCustomerNotesTable>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appAddToCartButton
          v-show="showAddToCartButton"
          class="matrix_addToCartButtonMain"
        ></appAddToCartButton>
        <appSummarySelectedPageOptions></appSummarySelectedPageOptions>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appOptionsTable>
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <appUploadTable alwaysShow="true"></appUploadTable>
        <appPersonalizationButton
          v-show="getPersonalizationFullPage"
          v-if="!getUploadPersonalizationOneProduct"
          class="matrix_personzalizeButtonMobile"
        >
        </appPersonalizationButton>
        <appAddToCartButton
          v-show="showAddToCartButton"
          class="matrix_addToCartButtonMobile"
        ></appAddToCartButton>
        <appQuotationButton></appQuotationButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useConfigStore } from "@/stores/modules/config";
import { useBundleStore } from "@/stores/modules/bundle";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePersonalizeStore } from "@/stores/modules/personalize";

export default {
  computed: {
    ...mapState(useConfigStore, [
      "getMatrixComplete",
      "getAddToCartFullPage",
      "getPersonalizationFullPage"
    ]),
    ...mapState(useBundleStore, [
      "getBundleProductPartType",
      "getBundleClass",
      "getBundleIsActive"
    ]),
    ...mapState(useWebproductStore, [
      "getUploadPersonalizationOneProduct",
      "getShowCustomerNotes"
    ]),
    ...mapState(usePersonalizeStore, ["getPersonalizationStatus"]),
    showAddToCartButton: function () {
      if (this.getUploadPersonalizationOneProduct) {
        // test also if the personalization has been made
        return this.getPersonalizationStatus && this.getAddToCartFullPage;
      } else return this.getAddToCartFullPage || this.getPersonalizationStatus;
    }
  }
};
</script>
